export default {
    default: 'histories/:id/histories',
    getHistoryById: '/histories/:id',
	updateHistoryById: '/histories/:id',
    setHistory: '/histories',
    getEmailOut: '/histories/get-mailing-out/:id',
    forwardEmailOut: 'reports/send-message/forward',
    deleteHistory: '/histories?id={id}&hisDetailId={hisDetailId}'
}